import React, { useState } from 'react'
import Reveal from 'react-reveal/Reveal'
import Toolbar from '../Navigation/Toolbar.js'
import './Layout.css'
import SidebarMenu from '../UI/SidebarMenu/SidebarMenu'

// Configure JSS

        const Layout = (props) => {
    const [path, setPath] = React.useState('');

    return (
            <div>
            
                <SidebarMenu content = {props.children} />
            
            </div>
            )
}
export default Layout